import { localeString, putEllipsis } from '@/config/helpers.js'
import { getEansCount } from '@/modules/campanhas/gestao-ofertas-v2/helpers/eans.js'
import { mapState } from 'vuex'
import { rules } from '../../helpers/rules.js'
import { findIndex } from 'lodash'
export const offerSalesTables = {
  props: {
    type: {
      type: String,
      required: false,
    },
    products: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    validations: {
      type: Object,
      default: () => {},
    },
    automaticCampaign: {
      type: Boolean,
      default: false,
    },
    disableMinAndMaxCpf: {
      type: Boolean,
      default: false,
    },
    isRevision: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    helpers: {
      type: Object,
      default: () => {},
    },
    group: {
      type: Object,
      default: () => {},
    },
    repeatedSkus: {
      type: Array,
      default: () => [],
    },
    groupIndexInOfferTypeProducts: {
      type: Number,
      default: 0,
    },
    groupIndex: {
      type: Number,
      default: 0,
    },
    search: {
      type: String,
      default: '',
    },
    isDisabledInRules: {
      type: Function,
      default: () => false,
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    hasSegments: {
      type: Boolean,
      default: false,
    },
    campaign: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    rules,
    options: {},
  }),
  computed: {
    ...mapState(['smartClientId']),
    minAndMaxPerClientTooltipMessage() {
      return 'Tudo que é cadastrado em um grupo público é exibido para seu consumidor final. Ainda não é possível compartilhar mínimos e máximos entre produtos, apesar de serem de um mesmo grupo. Por isso não é possível configurar esses limites neste tipo de grupo.'
    },
    modules() {
      return this.$getAllowedModules()
    },
    isJaneModulePermission() {
      if (this.$getAllowedModules()['jane']) return false
      return this.group.group_rules_exhibition === 'PUBLIC'
    },
    disableIfIsGrouped() {
      return this.type === 'grouped'
    },
    filteredProducts() {
      return this.products.filter((object) => JSON.stringify(object).toString().toLowerCase().includes(this.search.toLowerCase()))
    },
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
  },

  methods: {
    localeString,
    getEansCount,
    putEllipsis,
    removeItem(item) {
      if (this.type === 'grouped') this.$emit('remove-item', { item, groupId: this.group._id })
      else this.$emit('remove-item', { item })
    },
    isMultipleEans(item) {
      return item.product && item.product.eans.length > 1
    },
    toSet(arr) {
      return Object.keys(
        arr.reduce(function (seen, val) {
          seen[val] = true
          return seen
        }, {})
      )
    },
    addErrorClass(sku) {
      return this.repeatedSkus.includes(sku)
    },
    isCheckboxDisabled(currentEan, selectedEans) {
      const currentEanIsMarked = selectedEans.includes(currentEan)
      return Boolean(selectedEans.length === 1 && currentEanIsMarked)
    },
    getIndex(sku) {
      const index = findIndex(this.products, (product) => product.sku === sku)
      return index
    },
    getFranchiseeColor(percentage) {
      if (percentage <= 20) return '#FF0000'
      else if (percentage > 20 && percentage <= 40) return '#F39200'
      else if (percentage > 40 && percentage <= 60) return '#EFC941'
      else if (percentage > 60 && percentage <= 80) return '#0FC94D'
      else return '#0A8533'
    },
  },
}
